<template>
  <div>
      <div class="clearfix table-tools">
        <div class="buttons"></div>
        <div class="search">
          <a-form layout='inline' @submit="searchList">
            <a-form-item>
                <a-radio-group :value="searchData.zt_filter" @change="handleButZtChange">
                    <a-radio-button value="0">
                    全部板块
                    </a-radio-button>
                    <a-radio-button value="1">
                    涨停板块
                    </a-radio-button>
                </a-radio-group>
            </a-form-item>
           
            <a-form-item>
                <a-tooltip placement="topLeft" >
                    <template slot="title">
                    <span>代码</span>
                    </template>
                    <a-input v-model.trim="searchData.stock_code" allowClear placeholder="代码" style="width: 180px"/>
                </a-tooltip>
            </a-form-item> 
            <a-form-item>
                <a-tooltip placement="topLeft" >
                    <a-input v-model.trim="searchData.bk_sort" allowClear placeholder="day_sort" style="width: 180px"/>
                </a-tooltip>
            </a-form-item>
            <a-form-item class="block-line">
              <!-- <a-date-picker @change="onChange" allowClear v-model="searchData.created_at" /> -->
              <a-range-picker :ranges="rangesData" :disabled-date="disabledDate" allowClear v-model="searchData.created_at" :placeholder="['开始时间', '结束时间']"/>
            </a-form-item>
            <a-form-item>
              <a-button type="primary" html-type="submit" @click="searchList">搜索</a-button>
              <!-- <a-button type="primary" icon="reload" @click="updateFs">刷新</a-button> -->
            </a-form-item>
          </a-form>
        </div>
      </div>
      <div class="table">
        <vue-element-loading :active="loading" color="#00cca2" spinner="spinner"/>
        <a-table size="middle" :pagination="false" :bordered='false' rowKey="concept_code"
          :columns="columns" @change="handleChange" :dataSource="list">
            <template slot="index" slot-scope="text, record , index">
              <span>{{(index+1) + pageParams.perPage * (pageParams.currentPage - 1)}}</span>
            </template>
            <template slot="opt_content" slot-scope="text">
              <div v-html="text"></div>
            </template>
            <template slot="bk_name" slot-scope="text,record">
              
              <div @click="clkDetail(record)" :style="record.color?'background-color: yellow;':''">{{text}}</div>

              <a-tag color="red" v-for="(data,index) in record.kick_reason" :key="index" @click="getDetail(record,data)">
                  {{data}}
              </a-tag>

            </template>
            
            <template slot="stock_name" slot-scope="text, record , index">
                <a-badge status="success" />
                <span @click.stop v-clipboard:copy="record.stock_code" >{{text}}</span>
                <a-tag color="red" v-for="(data,index) in record.stock_short_tag" :key="index">
                  {{data}}
                </a-tag>
            </template>
            <template slot="stock_code" slot-scope="text, record , index">
                <a-badge :count="record.stock_kick_count" :offset=[15,0] :number-style="{
        backgroundColor: '#fff',
        color: 'red',
        boxShadow: '0 0 0 1px #d9d9d9 inset',
      }">
                  <span @click="clk(record.stock_code,record)">{{text}}</span>
                </a-badge>
            </template>
            <template slot="price" slot-scope="text, record , index">
                <span :style="color(text)"> {{ (formatNumber(text)) }}</span>
            </template>
            <template slot="B" slot-scope="text, record , index">
                <span>{{record.stock_bsm.rocket_buy}}</span>
            </template>
            <template slot="stock_chengjiaocha" slot-scope="text, record , index">
              <a-progress :percent="text" size="small" :show-info="false" />
            </template>
            <template slot="S" slot-scope="text, record , index">
                <span>{{record.stock_bsm.rocket_sell}}</span>
            </template>
        </a-table>
      </div>

      <a-modal v-model="editVisible" :title="stock_title" cancelText="取消" okText="刷新" width="1550px" @ok="handleOk" >
        <vue-element-loading :active="loadingP" color="#00cca2" spinner="spinner"/>
          <a-date-picker @change="onFsChange" />
            <ve-histogram 
            :data="predictChart" 
            v-if="false"
            :legend="{show:true,bottom:10}"
            judge-width
            :grid="{right: '5%'}"
            :mark-line="markLine"
            :title="{
                text:`${predictChart.title}`,
                textStyle: {
                    fontSize: 15,
                },
                subtextStyle: {
                    fontSize: 12.5
                }
            }"
            :settings="{
                label: { show: false, position: 'top'},
                yAxisType: ['KMB', 'KMB'], 
                showLine: ['M'],
                axisSite: { right: ['M'] }, 
            }" 
            :extend="histogramChartExtend" ></ve-histogram>

            <ve-histogram 
            :data="predictLiuruChart" 
            :legend="{show:true,bottom:10}"
            judge-width
            :grid="{right: '5%'}"
            :mark-line="markLine"
            :title="{
                text:`资金流入统计`,
                textStyle: {
                    fontSize: 15,
                },
                subtextStyle: {
                    fontSize: 12.5
                }
            }"
            :settings="{
                label: { show: false, position: 'top'},
                yAxisType: ['KMB', 'KMB'], 
                showLine: ['M'],
                axisSite: { right: ['M'] }, 
            }" 
            :extend="histogramChartExtend" ></ve-histogram>

            <a-table size="small" :pagination="false" :bordered='false' rowKey="id" :columns="columns2" :dataSource="liuruList">
                <template slot="index" slot-scope="text, record , index">
                <span>{{(index+1)}}</span>
                </template>
                <template slot="price" slot-scope="text, record , index">
                <span :style="color(text)"> {{ (formatNumber(text)) }}</span>
                </template>
            </a-table>
            <template>
        </template>
        <LEmpty v-if="first>0 && predictChart.rows.length == 0"/>
      </a-modal>

      <a-modal v-model="dVisible" :title="record.concept_name"  cancelText="取消" okText="刷新" width="1550px">
          <vue-element-loading :active="dlLoading" color="#00cca2" spinner="spinner"/>
          <ve-histogram 
            :data="liuruChart" 
            :legend="{show:true,bottom:10}"
            judge-width
            :grid="{right: '5%'}"
            :title="{
                text:`资金流入统计`,
                textStyle: {
                    fontSize: 15,
                },
                subtextStyle: {
                    fontSize: 12.5
                }
            }"
            :settings="{
                label: { show: false, position: 'top'},
                yAxisType: ['KMB', 'KMB'], 
                showLine: ['M'],
                axisSite: { right: ['M'] }, 
            }" 
            :extend="histogramChartExtend" ></ve-histogram>

          
          <!-- <a-radio-group :value="searchData.shsz" @change="handleButChange">
              <a-radio-button value="sh">
              主板
              </a-radio-button>
              <a-radio-button value="sz">
              创业
              </a-radio-button>
          </a-radio-group> -->
          
          <!-- <a-radio-group>
              <a-radio-button :value="searchData.rsi" @click="handleButRsiChange(1)">
              rsi
            </a-radio-group>  
          </a-radio-button>
           -->

          <a-radio-group :value="searchData.bk_date" @change="handleButDateChange">
              <a-radio-button :value="data.日期" v-for="data in liuruChart.rows" v-if="data.日期.length < 6">
              {{data.日期}}
              </a-radio-button>
          </a-radio-group>
          <hr/>

          <a-radio-group>
              <a-radio-button @click="handleButAddChange()">
              +
              </a-radio-button>  
          </a-radio-group>
          <hr />

          <a-radio-group :value="searchData.bk_sort" @change="handleSort">
              <a-radio-button :value="data" :key="idx" v-for="(idx,data) in sort_list">
                {{idx}}
              </a-radio-button>
          </a-radio-group>
          <hr/>

          <a-table size="small" :pagination="false" :bordered='false' rowKey="code" :columns="columns2" :dataSource="detail_list" @change="handleChange2">
                <template slot="index" slot-scope="text, record , index">
                <span>{{(index+1)}}</span>
                </template>
                <template slot="price" slot-scope="text, record , index">
                <span :style="color(text)"> {{ (formatNumber(text)) }}</span>
                </template>
                <template slot="stock_code" slot-scope="text, record , index">
                  <span @click.stop v-clipboard:copy="record.stock_code">{{text}}</span>
                </template>
                <template slot="stock_name" slot-scope="text, record , index">
                  <a-badge status="success" v-if="record.isHigh" />
                  <span>{{text}}</span>
                </template>
                <template slot="fs_low_minute" slot-scope="text, record , index">
                    <span :style="{ color: text == '0' ? 'red' : '' }"> {{ ((text)) }}</span>
                </template>
                <template slot="fs_one_total" slot-scope="text, record , index">
                    <span> {{ ((text.bili)) }}</span>
                </template>
                <template slot="fs_one_total_m" slot-scope="text, record , index">
                    <span> {{ (formatNumber(text.stock_total)) }}</span>
                </template>
                <template slot="stock_short_count" slot-scope="text, record , index">
                    <span>{{record.stock_yes_short_count}}/{{record.stock_short_count}}</span>
                </template>
                <template slot="stock_zhangdiefu_zuixin" slot-scope="text, record , index">
                  <span :style="zuixincolor(text,record.stock_zhangdiefu)"> {{ (formatNumber(text)) }}</span>
                </template>
            </a-table>
      </a-modal>

      <a-modal v-model="fsVisible" width="1550px">
        <ve-histogram 
            :data="fs_list_chart" 
            :legend="{show:true,bottom:10}"
            judge-width
            :grid="{right: '5%'}"
            :mark-line="markLine"
            :title="{
                textStyle: {
                    fontSize: 15,
                },
                subtextStyle: {
                    fontSize: 12.5
                }
            }"
            :settings="{
                label: { show: false, position: 'top'},
                yAxisType: ['KMB', 'KMB'], 
                showLine: ['P','A'],
                axisSite: { right: ['P','A'] }, 
            }" 
            :extend="histogramChartExtend" ></ve-histogram>

      </a-modal>
  </div>
</template>

<script>
const columns = [
  { title: '#', width:'70px', scopedSlots: { customRender: 'index' }, key: 'id' ,sorter:()=>{}},
  { title: '板块', align:'center', dataIndex: 'concept_name', key: 'concept_name',sorter:()=>{}, scopedSlots: { customRender: 'bk_name' },width:'220px'},
  { title: 'kick', align:'center', dataIndex: 'kick_count', key: 'kick_count',sorter:()=>{}},
  { title: '60日新高', align:'center', dataIndex: 'gap_count', key: 'gap_count',sorter:()=>{}},
  { title: 'short', align:'center', dataIndex: 'short_count', key: 'short_count',sorter:()=>{}},
  { title: 'short_bili', align:'center', dataIndex: 'short_bili', key: 'short_bili',sorter:()=>{}},
  { title: 'stock', align:'center', dataIndex: 'stock_count', key: 'stock_count',sorter:()=>{}},
  { title: 'code', align:'center', dataIndex: 'concept_code', key: 'concept_code',sorter:()=>{}},
  { title: '涨幅', align:'center', dataIndex: 'avgp', key: 'avgp',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  // { title: '涨速',  align:'center', dataIndex: 'gainSpeed', key: 'gainSpeed',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  { title: '昨日',  align:'center', dataIndex: 'yes_liuru', key: 'yes_liuru',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  { title: '流入',  align:'center', dataIndex: 'liuru', key: 'liuru',sorter:()=>{}, scopedSlots: { customRender: 'price' }},

  { title: 'Gap',  align:'center', dataIndex: 'gap_liuru', key: 'gap_liuru',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  
  
  { title: '昨日',  align:'center', dataIndex: 'yes_deal', key: 'yes_deal',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  { title: '成交',  align:'center', dataIndex: 'stock_chengjiaoe', key: 'stock_chengjiaoe',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  // { title: '流比',  align:'center', dataIndex: 'liuru_bili', key: 'liuru_bili',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  // { title: 'bk_rsi6', align:'center', dataIndex: 'bk_rsi6', key: 'bk_rsi6'},
  // { title: 'bk_rsi6_cha', align:'center', dataIndex: 'bk_rsi6_cha', key: 'bk_rsi6_cha'},
  { title: 'stock_day_sort', align:'center', dataIndex: 'stock_day_sort', key: 'stock_day_sort'},
  { title: 'stock_updatetime', align:'center', dataIndex: 'stock_updatetime', key: 'stock_updatetime'},
]

const columns2 = [
  { title: '#', width:'35px', scopedSlots: { customRender: 'index' }, key: 'id' ,sorter:()=>{}} ,
  { title: '代码', align:'center', dataIndex: 'stock_code', key: 'stock_code',sorter:()=>{}, scopedSlots: { customRender: 'stock_code' }},
  { title: '名称', align:'center', dataIndex: 'stock_name', key: 'stock_name', scopedSlots: { customRender: 'stock_name' }},
  // { title: '涨速', align:'center', dataIndex: 'stocck_5zhangsu', key: 'stocck_5zhangsu'},
  // { title: '涨停', align:'center', dataIndex: 'stock_kick_sale', key: 'stock_kick_sale', scopedSlots: { customRender: 'price' }},
  { title: '5日', width: 70, align:'center', dataIndex: 'stock_5day_zhangfu', key: 'stock_5day_zhangfu', scopedSlots: { customRender: 'price' }},
  // { title: '振幅', width: 70, align:'center', dataIndex: 'stock_5day_zhenfu', key: 'stock_5day_zhenfu'},
  // { title: '连续', width: 70, align:'center', dataIndex: 'lxsz_count', key: 'lxsz_count',sorter:()=>{}},
  { title: '均下', width: 70, align:'center', dataIndex: 'fs_low_minute', key: 'fs_low_minute',sorter:()=>{}},
  { title: '涨幅', align:'center', dataIndex: 'stock_zhangdiefu', key: 'stock_zhangdiefu',sorter:()=>{}},
  { title: '今收', width: 70, align:'center', dataIndex: 'stock_zhangdiefu_zuixin', key: 'stock_zhangdiefu_zuixin', scopedSlots: { customRender: 'stock_zhangdiefu_zuixin' },sorter:()=>{}},
  { title: 'ONE', width: 70, align:'center', dataIndex: 'fs_one_total', key: 'fs_one_total',sorter:()=>{}, scopedSlots: { customRender: 'fs_one_total' }},  
  { title: 'ONEM', width: 100, align:'center', dataIndex: 'fs_one_total', key: 'fs_one_total_m',sorter:()=>{}, scopedSlots: { customRender: 'fs_one_total_m' }},
  // { title: 'S', width: 40, align:'center', dataIndex: 'stock_short_count', key: 'stock_short_count',sorter:()=>{}},
  // { title: 'K', width: 40, align:'center', dataIndex: 'stock_kick_count', key: 'stock_kick_count',sorter:()=>{}},
  { title: '量比', width: 70, align:'center', dataIndex: 'stock_liangbi', key: 'stock_liangbi',sorter:()=>{}},
  { title: '流通', align:'center', dataIndex: 'stock_liutongshizhi', key: 'stock_liutongshizhi', scopedSlots: { customRender: 'price' },sorter:()=>{}},
  { title: '今日', align:'center', dataIndex: 'stock_chengjiaoe', key: 'stock_chengjiaoe' , scopedSlots: { customRender: 'price' },sorter:()=>{}},
  { title: '昨日', align:'center', dataIndex: 'stock_yesterday_liuru', key: 'stock_yesterday_liuru',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  { title: '流入', align:'center', dataIndex: 'stock_liuru', key: 'stock_liuru',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  { title: 'Gap', align:'center', dataIndex: 'stock_gap_liuru', key: 'stock_gap_liuru',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  { title: 'rsi6', align:'center', dataIndex: 'stock_rsi6', key: 'stock_rsi6',sorter:()=>{}},
  { title: 'cha', align:'center', dataIndex: 'stock_rsi6_cha', key: 'stock_rsi6_cha',sorter:()=>{}},
  { title: 'zuixin', align:'center', dataIndex: 'stock_cha_zuixin', key: 'stock_cha_zuixin',sorter:()=>{}},
  { title: 'stock_kick', align:'center', dataIndex: 'stock_kick_time', key: 'stock_kick_time',sorter:()=>{}},
  // { title: 'stock_updatetime', align:'center', dataIndex: 'stock_updatetime', key: 'stock_updatetime'},
]

import C_ITEMS from '@/utils/items'
import ranges from "@/common/mixins/ranges"
import moment from 'moment'
import tableMixins from '@/common/mixins/table'

export default {
  name: 'operation',
  provide() {
    return {
      parent: this
    }
  },

  components: {
    // refundModal
  },

  data() {
    this.chartSettings = {
        xAxisType: ['KMB', 'percent'],
      }
      this.markLine = {
          symbol: ['none', 'none'], //去掉箭头
          data: [],
          label:{
              position:'insideStartTop'
          }
      },
      this.tooltip = {
          show:true,  
          trigger: "axis",
          alwaysShowContent:true,
          formatter: function(params) { 
            var res;
            console.log(params)
            return res;
          }
        },
      this.chartStockSettings = {
        yAxis:{
          show:false,
        },
        grid: {
          containLabel: true,
        },
        showDataZoom: false,
        start: 0,
        end: 100,
        showMA: false,
        MA: [5,10],
        legendName: {}, 
        showVol: false,
        upColor: '#FF8787',
        downColor: '#7FB77E',
      }
      this.markLine = {
          symbol: ['none', 'none'], //去掉箭头
          data: [],
          label:{
              show: false, //隐藏标示文字
              position:'insideEndTop'
          }
      },
      this.toolbox = {
          feature: {
          magicType: {},
          saveAsImage: {pixelRatio:2}
          }
      }
    return {
      loading: false,
      dVisible: false,
      fsVisible:false,
      dlLoading:false,
      first:0,
      pageSizeOptions: ['10', '20', '30', '40', '100'],
      current: 1,
      pageParams: {
        currentPage: 1,
        pageCount: 50,
        perPage: 10,
        totalCount: 0
      },
      fs_list:[],
      fs_list_chart:[],
      stock_title:'',
      stock_detail:{},
      columns,
      columns2,
      sort_list:{
        "0": 915,
        "1": 920,
        "2": 925,
        "3": 930,
        "4": 935,
        "5": 940,
        "6": 945,
        "7": 950,
        "8": 955,
        "9": 1000,
        "10": 1005,
        "11": 1010,
        "12": 1015,
        "13": 1020,
        "14": 1025,
        "15": 1030,
        "16": 1035,
        "17": 1040,
        "18": 1045,
        "19": 1050,
        "20": 1055,
        "21": 1100,
        "22": 1105,
        "23": 1110,
        "24": 1115,
        "25": 1120,
        "26": 1125,
        "27": 1130,
        "28": 1135,
        "29": 1300,
        "30": 1305,
        "31": 1310,
        "32": 1315,
        "33": 1320,
        "34": 1325,
        "35": 1330,
        "36": 1335,
        "37": 1340,
        "38": 1345,
        "39": 1350,
        "40": 1355,
        "41": 1400,
        "42": 1405,
        "43": 1410,
        "44": 1415,
        "45": 1420,
        "46": 1425,
        "47": 1430,
        "48": 1435,
        "49": 1440,
        "50": 1445,
        "51": 1450,
        "52": 1455,
        "53": 1500,
        "54": 1505
      },
      searchParams: {
        "page": 1,
        "per-page": 10,
        "search": {},
        "sort": ''
      },
      list: [],
      operationTypes: C_ITEMS.operationTypes,
      searchData: {
        shsz:'sz',
        zt_filter:'0',
        rsi:'0',
        keyword:'',
        bk_date:'',
        m5:'0',
        bk_sort:'',
      },
      record:{},
      visible: false,
      editVisible:false,
      refundVisible: false,
      exportLoading: false,
      histogramChartExtend:{
        series(item){
            console.log(item)
                if(item){
                    item[0].barMaxWidth = 10
                    item[0].color='#23d9ae'

                    if(item[1]){
                      item[1].color='red'
                    }

                    if(item[3]){
                      item[3].color='#FF6600'
                    }
                }
                return item
            },
            xAxis:{
                axisLine:{
                    show:true,
                    lineStyle: {
                        type: 'dotted',
                    }
                },
            },
            yAxis(item){
                item[0].axisLine = Object.assign({}, {
                    show:false
                })
                item[0].splitLine = Object.assign({}, {
                    show:true,
                    lineStyle: {
                        type: 'dotted'
                    }
                })
                return item
            },
        },
        pie:{},
        stockCode:'',
        predictMsg:[],
        stockChartData:[],
        dailyChart:[],
        predictChart:[],
        detail_list:[],
        predictLiuruChart:[],
        loadingP:false,
        liuruChart:[],
        liuruList:[],
    }
  },
  mixins: [ ranges, tableMixins ],
  created() {
    this.searchData.created_at =[moment().subtract('days',0).format('YYYY-MM-DD'),moment().subtract('days',0).format('YYYY-MM-DD')]
  },
  methods: {
    updateFs(){
      console.log('test');
    },
    zuixincolor(value,target){
        if(Number(value) < Number(target)){
          return {color:'green'};
        }
        if(value==0){
          return '';
        }
        if(Number(value) > Number(target)){
          return {color:'red'};
        }
    },
    handleButDateChange(e){
        this.searchData.bk_date = e.target.value
        this.getDetail(this.record,this.searchData.keyword)
    },
    handleButChange(e){
        this.searchData.shsz = e.target.value
        this.getDetail(this.record,this.searchData.keyword)
    },
    handleButAddChange(){
        this.getDetail(this.record,this.searchData.keyword,'1')
    },
    handleSort(e){
        this.searchData.bk_sort = e.target.value;
        this.getDetail(this.record,this.searchData.keyword)
    },
    handleButZtChange(e){
        this.searchData.zt_filter = e.target.value
        this.getList()
    },
    handleButRsiChange(e){
        if(e == this.searchData.rsi){
          this.searchData.rsi = 0;
        }else{
          this.searchData.rsi = e
        }
        this.getDetail(this.record,this.searchData.keyword)
    },
    handleButM5Change(e){
        if(e == this.searchData.m5){
          this.searchData.m5 = 0;
        }else{
          this.searchData.m5 = e
        }
        this.getDetail(this.record,this.searchData.keyword)
    },
    filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    onFsChange(date, dateString) {
        this.paramsData.search.stock_date = dateString
        this.getPredictChart(this.stockCode);
    },
    clkDetail(record){
      this.searchData.bk_date = '';
      this.getDetail(record)
    },
    clkFs(data){
        this.fsVisible = true;
        this.fs_list = data.sub_fs;
        this.fs_list_chart = data.sub_fs_chart;
    },
    closeSearch() {
      this.visible = false
    },
    async handleOk() {
        this.getPredictChart(this.stockCode)  
    },
    clk(stock_code,stock_detail){
      this.stockCode = stock_code;
      this.stock_detail = stock_detail;
      this.searchData.bk_date = this.searchData.start_date
      this.getPredictChart(stock_code)
    },
    async getPredictChart(stock_code) {
      this.editVisible = true;
      this.loadingP = true;
      let res = await this.$store.dispatch('enterpriseLabLiuruAction', {data:{search:{stock_name:stock_code,stock_updatetime:this.stock_detail.stock_updatetime}}})
      this.predictChart = res.data.predict_chart
      this.predictLiuruChart = res.data.predict_liuru_chart
      this.pie = res.data.pie
      this.stock_title =  this.stock_detail.stock_name + ' ' + res.data.pie_title
      this.liuruList = res.data.liuru_list
      this.predictMsg = res.data.fs_list
      this.fs_list_chart = res.data.sub_fs_chart;
      this.loadingP = false
    },
    color(value){
        if(value < 0){
          return {color:'green'};
        }
        if(value==0){
          return '';
        }
        if(value > 0){
          return {color:'red'};
        }
    },
    formatNumber(value) {
      let flag = '';
      if(value<0){
        value=Math.abs(value)
        flag = '-';
      }
      if (value >= 100000000) {
        return flag+(value / 100000000).toFixed(2) + ' 亿';
      } else if (value >= 10000) {
        return flag+(value / 10000).toFixed(2) + ' 万';
      } else if (value >= 1000) {
        return flag+(value / 1000).toFixed(2) + ' 千';
      } else {
        return flag+value;
      }
    },
    handleChange(pagination, filters, sorter){
        if(sorter.order){
            console.log(sorter);
            if(sorter.order === "ascend"){
                this.searchParams['sort'] = `${sorter.column.key}`
            }else{
                this.searchParams['sort'] = `-${sorter.column.key}`
            }
            }else{
            this.searchParams['sort'] = ''
            }
        this.getList()
    },
    handleChange2(pagination, filters, sorter){
        if(sorter.order){
            if(sorter.order === "ascend"){
                this.searchParams['sort'] = `${sorter.column.key}`
            }else{
                this.searchParams['sort'] = `-${sorter.column.key}`
            }
            }else{
              this.searchParams['sort'] = ''
        }
        this.getDetail(this.record,this.searchData.keyword)
    },
    async getList() {
      this.loading = true
      let obj = {}
      let { searchData } = this
      if (searchData) {
        for (let k in searchData) {
          if (k === 'created_at') {
            obj['start_date'] = searchData[k][0]?moment(searchData[k][0]).format('YYYY-MM-DD'):''
            obj['end_date'] = searchData[k][1]?moment(searchData[k][1]).format('YYYY-MM-DD'):''
          } else {
            obj[k] = searchData[k]
          }
        }
      }
      this.searchParams.search = obj
      let res = await this.$store.dispatch('enterpriseLabStockBkListAction', { data: this.searchParams })
      this.list = res.items
      this.loading = false
    },
    async getDetail(record,keyword,add) {
      this.searchData.keyword = keyword;
      this.dVisible = true;
      this.record = record;
      if(keyword){
        // this.record.concept_name = keyword;
      }
      this.dlLoading = true;

      let obj = {}
      let { searchData } = this
      if (searchData) {
        for (let k in searchData) {
          if (k === 'created_at') {
            obj['start_date'] = searchData[k][0]?moment(searchData[k][0]).format('YYYY-MM-DD'):''
            obj['end_date'] = searchData[k][1]?moment(searchData[k][1]).format('YYYY-MM-DD'):''
          } else {
            obj[k] = searchData[k]
          }
        }
      }
      if(add){
        obj['add'] = add;
      }  
      this.searchParams.search = obj
      this.searchParams.code = record.concept_code
      let res = await this.$store.dispatch('enterpriseLabStockBkDetailAction', { data: this.searchParams })
      this.detail_list = [];
      this.detail_list = res.data.list
      this.liuruChart = res.data.liuru_chart
      // this.loading = false
      this.dlLoading = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.cell-content {
  white-space: normal; /* 允许换行 */
  word-wrap: break-word; /* 长单词换行 */
}
.ant-modal-body .ant-row{
    margin: 10px 20px !important;
}
</style>